<template>
  <component
    v-if="centerData.length > 0"
    :is="ContentByScope[scope]"
    :data="getScopedData()"
    :initial-item-orders="initialItemOrders"
  />
  <div v-else>Loading....</div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import HelpCenterComponent from "@/app/entities/components/helpCenter/index.vue";
import { helpCenterManager } from "@/app/entities/services/help-center";
import { HelpCenterItem } from "@/@types/entities/helpcenter";

const props = defineProps<{
  scope: string;
  initialItemOrders?: number[];
}>();

const centerData = ref<HelpCenterItem[]>([]);

const WORKSPACE_HELP_DATA = {
  type: "menu_workspace",
  items: [
    {
      id: 1,
      order: 1,
      title_menu: "Cola actual y cola de primera interacción",
      subtitle_menu: "¿Cuál es la diferencia entre estas colas?",
      show_submenu: true,
      information: {
        title: "",
        icon: null,
        content: [
          {
            title: "Cola actual",
            text: "Es la cola donde se encuentra el ticket en este momento. Esta información se actualiza cada vez que el ticket es transferido a nueva cola dentro de la campaña.",
            image: null,
            order: 1
          },
          {
            title: "Cola de primera interacción",
            text: "Es la cola donde se registró la primera interacción por parte del contacto vía mensajería o llamada. Esta información no cambia en todo el período de vida del ticket.",
            image: null,
            order: 2
          }
        ]
      }
    }
  ]
};

const ContentByScope: Record<string, unknown> = {
  tab_forms: HelpCenterComponent,
  tab_chatbots: HelpCenterComponent,
  tab_imports: HelpCenterComponent,
  tab_strategies: HelpCenterComponent,
  tab_sequences: HelpCenterComponent,
  tab_integrations: HelpCenterComponent,
  tab_email_templates: HelpCenterComponent,
  tab_email: HelpCenterComponent,
  menu_workspace: HelpCenterComponent,
};

const fetchHelpCenterInfo = async () => {
  if (props.scope === "menu_workspace") {
    centerData.value = [WORKSPACE_HELP_DATA as unknown as HelpCenterItem];
  } else {
    const response = await helpCenterManager.getHelpCenterInfo(props.scope);
    centerData.value = response;
  }
};

const getScopedData = () => (centerData.value.length > 0 ? centerData.value[0] : null);

onMounted(async () => {
  await fetchHelpCenterInfo();
});

watch(
  () => props.scope,
  async (newScope, oldScope) => {
    if (newScope !== oldScope) {
      await fetchHelpCenterInfo();
    }
  }
);
</script>

<style scoped lang="sass"></style>
